import checkoutStepBase from '@webapix/shop-js/src/mixins/checkoutStepBase'
import api from '@webapix/shop-js/src/api/checkout'

export default {
    mixins: [checkoutStepBase],

    data() {
        return {
            email: null,
            password: null,
            errors: {}
        }
    },

    methods: {
        async login() {
            try {
                const refreshCallback = this.refreshPage
                const response = await api.login(this.email, this.password)

                setTimeout(this.refreshPage, 1000)

                let _coupons = this.$store.state.cart.discounts.filter(item => typeof item.code !== undefined)
                let _coupon = ''
                if ( _coupons.length ) {
                    _coupon = _coupons[0].code
                }

                const payload = {
                    items: this.$store.state.cart.items.map(
                        item => {
                            return {
                                id: item.id.identifier,
                                name: item.name,
                                quantity: item.quantity,
                                price: item.price.gross
                            }
                        }
                    ),
                    'coupon': _coupon,
                    'checkout_step': 1,
                    'checkout_option': 'user logged in',
                    'event_callback': refreshCallback
                }
                
                gtag('event', 'checkout_progress', payload)

            } catch (exception) {
                const response = exception.response

                if (response && response.status === 422) {
                    this.errors = response.data.errors
                } else {
                    console.error('Login failure!', exception)
                }
            }
        },

        refreshPage() {
            window.location.reload()
        },
    }
}
